import { ReactNode, useMemo } from "react";

export const useIsQa = () => {
  return useMemo(() => {
    // todo: don't rely on URL, use vite env var instead
    const host = window.location.hostname;
    return host === "qa.copilot.thalolabs.com";
  }, [window.location.hostname]);
}

export const QAOnly = ({ children } : {children: ReactNode}) => {
  const isQa = useIsQa();

  if (!isQa) return;

  return children
}
